import React from "react";
import "./theme-toggle.scss";

export default function ThemeToggle({ isDark, onToggle }) {
  return (
    <button
      type="button"
      className={`theme-switch${isDark ? " is-dark" : ""}`}
      onClick={onToggle}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      aria-pressed={isDark}
    >
      <span className="theme-switch__sky" aria-hidden="true">
        <span className="theme-switch__cloud theme-switch__cloud--a" />
        <span className="theme-switch__cloud theme-switch__cloud--b" />
        <span className="theme-switch__star theme-switch__star--a" />
        <span className="theme-switch__star theme-switch__star--b" />
        <span className="theme-switch__star theme-switch__star--c" />
        <span className="theme-switch__mover">
          <span className="theme-switch__rays">
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
          </span>
          <span className="theme-switch__thumb">
            <span className="theme-switch__moon" />
          </span>
        </span>
      </span>
    </button>
  );
}
